module.exports = __webpack_public_path__ + "static/media/HOW TO TURN ON AUTOMATIC EMAIL IMPORT.afce62fd.png";